import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
    },
    {
      path: '/buyout/create',
      name: 'createBuyout',
      props: true,
      component: () => import('./views/BuyoutCreate.vue'),
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import('./views/Orders.vue'),
    },
    {
      path: '/buy-phones',
      name: 'buy-phones',
      component: () => import('./views/BuyPhones.vue'),
    },
    {
      path: '/apple-watch',
      name: 'apple-watch',
      component: () => import('./views/Applewatch.vue'),
    },
    {
      path: '/stores',
      name: 'stores',
      component: () => import('./views/Stores'),
    },
    {
      path: '/stores/:id',
      name: 'store',
      component: () => import('./views/Store'),
    },
    {
      path: '/summary',
      name: 'summary',
      component: () => import('./views/Summary'),
    },
    {
      path: '/ransoms',
      name: 'ransoms',
      component: () => import('./views/Ransoms'),
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = Vue.$storage.get('token');

  if (authRequired && !loggedIn) {
    router.push({ name: 'login' });
    return
    // return next('/login');
  }

  return next();
});

export default router;
